var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<a ng-click=\"open_modal()\" class=\"fancybox-modal send button-edit send-button\">Send</a>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/sendApplicationLink/sendApplicationLink.jade
// module id = 523
// module chunks = 0